<ng-container *ngIf="inlineEditor else popupEditor">
    <se-masked-date-cell-editor-inline tabindex="0"
                                 [value]="value"
                                 [startEdited]="cellStartEdited"
                                 [required]="required"
                                 [inputType]="inputType"
                                 [dateInputFormat]="dateInputFormat"
                                 [timeInputFormat]="timeInputFormat"
                                 [dateTimeInputFormat]="dateTimeInputFormat"
                                 [dateSeparator]="dateSeparator"
                                 [timeSeparator]="timeSeparator"
                                 (formReady)="_onFormReady($event)">
    </se-masked-date-cell-editor-inline>
</ng-container>

<ng-template #popupEditor>
    <se-masked-date-cell-editor-popup tabindex="0"
                                [value]="value"
                                [inputType]="inputType"
                                [width]="cellWidth"
                                [dateInputFormat]="dateInputFormat"
                                [timeInputFormat]="timeInputFormat"
                                [dateTimeInputFormat]="dateTimeInputFormat"
                                [dateSeparator]="dateSeparator"
                                [timeSeparator]="timeSeparator"
                                (formReady)="_onFormReady($event)">
    </se-masked-date-cell-editor-popup>
</ng-template>


